"use strict";

require("custom-event-polyfill");

require("./ElementPolyfill");